import React, { useEffect } from 'react';
import Icon from '@ramsey-design-system/icon';
import { SuccessIcon, ErrorIcon } from '@ramsey-design-system/icons';

// Styles
import styles from './response-question-template.module.css';
import '@ramsey-design-system/icon/dist/icon.css';

type ToastMessageProps = {
  type: 'success' | 'error' | null;
  setToast: React.Dispatch<React.SetStateAction<'success' | 'error' | null>>;
};

function ToastMessage({ type, setToast }: ToastMessageProps) {
  useEffect(() => {
    if (type !== null) {
      setTimeout(() => setToast(null), 3000);
    }
  }, [type]);

  let classNames =
    type === null ? styles.hide : `${styles.show} ${styles.message}`;
  let icon;
  let message;

  if (type === 'success') {
    classNames += ` ${styles.successMessage}`;
    icon = <Icon size="large" icon={SuccessIcon} />;
    message = 'Answer Saved!';
  } else if (type === 'error') {
    classNames += ` ${styles.errorMessage}`;
    icon = <Icon size="large" icon={ErrorIcon} />;
    message = 'Something went wrong.';
  }

  return (
    <div className={classNames}>
      {icon}
      <span>{message}</span>
    </div>
  );
}

export default ToastMessage;
